import { masters } from "./masters";
import { opd } from "./opd";
import { ipd } from "./ipd";
import { diagnosis } from "./diagnosis";
import { mis } from "./mis";
import { medicalStore } from "./medicalStore";
import { accounts } from "./accounts";
import { utility } from "./utility";
import { messaging } from "./messaging";

export const permissions = [
  ...masters,
  ...opd,
  ...ipd,
  ...diagnosis,
  ...mis,
  ...medicalStore,
  ...accounts,
  ...utility,
  ...messaging
];
